import React from 'react';

import HeaderContainer from 'containers/common/HeaderContainer';
import Footer from 'components/common/Footer';
import LayerPopupContainer from 'containers/common/LayerPopupContainer';

import styles from './PageTemplateN.scss';
import classNames from 'classnames/bind';
// import Footer from 'components/common/Footer';

const cx = classNames.bind(styles);

const PageTemplate = ({children}) => (
  <div className={cx('page-template')}>
    <HeaderContainer/>
    <div className={cx('main')}>
      {children}
    </div>
    <Footer/>
    <LayerPopupContainer/>
  </div>
);

export default PageTemplate;